import React, { useRef, useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Grid,
    Typography,
    Box,
    Chip,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button
} from '@material-ui/core';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LessonQuestionsData from 'services/dataService/LessonQuestionsData';
import { format } from 'date-fns';
import { useStyles } from './style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ArrowBackIos } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';


const UserExams = () => {
    const tableRef = useRef();
    const classes = useStyles();
    const [details, setDetails] = useState();
    const [loading, setLoading] = useState(true);
    const { id, id_course } = useParams();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation(['tables', 'button']);



    async function getUserDetailsExams() {
        try {
            setLoading(true);
            const id_enrollment =
              new URLSearchParams(location.search).get('id_enrollment');
            const response = await LessonQuestionsData.getExamDetailsAdmin(
                id,
                id_course,
                id_enrollment ? { id_enrollment } : {}
            );
            setDetails(response.data || {});
        } catch (error) {
            setDetails(null);
            console.error('Avaliação ainda não foi realizada:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getUserDetailsExams();
    }, [id, id_course, location.search]);

    if (loading) return <div>Carregando...</div>;
    if (!details) return <div>Nenhuma avaliação encontrada.</div>;

    const { user, attempts, lesson } = details;

    return (
        <Box p={2}>
            <Grid item md={3} xs={4}>
                <Button
                    color="primary"
                    variant="outlined"
                    style={{marginBottom: 8}}
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIos style={{ marginRight: '4px' }} />
                    {t('button:commons.btn_back')}
                </Button>
            </Grid>
            <Card className={classes.card}>
                <CardContent>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Grid container alignItems="center" spacing={2}>
                                <Grid item>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        width={60}
                                        height={60}
                                        borderRadius="50%"
                                        bgcolor="#1E88E5"
                                        color="white"
                                        fontWeight="bold"
                                        fontSize="1.25rem"
                                    >
                                        {user?.name?.[0]}
                                    </Box>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                        {user?.name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {user?.email}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {user?.course}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Grid
                                container
                                spacing={4}
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Grid item>
                                    <Box textAlign="center" minWidth={80}>
                                        <Typography variant="h4" style={{ color: '#1E88E5' }}>
                                            {attempts?.length || 0}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Avaliações
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid item>
                                    <Box textAlign="center" minWidth={80}>
                                        <Typography variant="h4" style={{ color: '#43A047' }}>
                                            {attempts && attempts.length > 0
                                                ? (
                                                    (attempts.reduce((sum, att) => sum + Number(att.score), 0) /
                                                        attempts.length) *
                                                    100
                                                ).toFixed(1)
                                                : '0.0'}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Média
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item>
                                    <Box textAlign="center" minWidth={80}>
                                        <Typography variant="h4" style={{ color: '#03A9F4' }}>
                                            {attempts && attempts.length > 0
                                                ? (
                                                    (attempts.reduce((sum, att) => sum + Number(att.score), 0) /
                                                        attempts.length) *
                                                    100
                                                ).toFixed(1) + '%'
                                                : '0%'}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Acertos
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Typography variant="h5" gutterBottom style={{ margin: '16px 0 0 4px' }}>
                Histórico de Avaliações
            </Typography>
            {attempts?.map((attempt, idx) => (
                <Box key={attempt.id_attempt} mt={2}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Grid container spacing={2} alignItems="flex-end">
                                <Grid item xs={12} md={10}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                                        Avaliação - {attempt.lesson_title || `Tentativa ${idx + 1}`}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {format(new Date(attempt.created_at), 'dd/MM/yyyy - HH:mm')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} md={1}>
                                    <Typography variant="h4">
                                        {(Number(attempt.score) * 100).toFixed(0)}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">Nota</Typography>
                                </Grid>
                                <Grid item xs={4} md={1}>
                                    <Typography variant="h4" style={{ color: '#4CAF50' }}>
                                        {attempt.exams.filter(exam =>
                                            exam.answers.some(ans => ans.is_correct && ans.is_user_answer)
                                        ).length}/{attempt.exams.length}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">Acertos</Typography>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: 'block' }}>
                            <Grid container spacing={2} mb={2}>
                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Total de Questões
                                            </Typography>
                                            <Typography variant="h3">{attempt.exams.length}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="subtitle2" color="textSecondary">
                                                Acertos
                                            </Typography>
                                            <Typography variant="h3" style={{ color: '#42D780' }}>
                                                {
                                                    attempt.exams.filter(exam =>
                                                        exam.answers.some(ans => ans.is_correct && ans.is_user_answer)
                                                    ).length
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Card>
                                        <CardContent>
                                            <Typography variant="subtitle2" >
                                                Erros
                                            </Typography>
                                            <Typography variant="h3" style={{ color: '#E64D4D' }}>
                                                {
                                                    attempt.exams.filter(exam =>
                                                        !exam.answers.some(ans => ans.is_correct && ans.is_user_answer)
                                                    ).length
                                                }
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            {attempt.exams.map((exam, qIndex) => (
                                <Card
                                    key={exam.id_lesson_content_exams}
                                    style={{
                                        marginTop: 16,
                                        marginBottom: 16,
                                        borderLeft: exam.answers.some(
                                            (ans) => ans.is_correct && ans.is_user_answer
                                        )
                                            ? '2px solid #4caf50'
                                            : '2px solid #f44336',
                                        borderRadius: 8,
                                    }}
                                >
                                    <CardContent>
                                        <Box display="flex" alignItems="center" mb={1}>
                                            {exam.answers.some((ans) => ans.is_correct && ans.is_user_answer) ? (
                                                <img
                                                    alt="check-circle-green"
                                                    height={30}
                                                    width={30}
                                                    style={{ marginRight: 8 }}
                                                    src="/images/check-circle-green.svg"
                                                />
                                            ) : (
                                                <CancelIcon style={{ color: '#f44336', marginRight: 8 }} />
                                            )}
                                            <Typography style={{ fontWeight: 500 }} variant="subtitle1">
                                                {exam.order + 1} - {exam.question}
                                            </Typography>
                                        </Box>

                                        <Divider style={{ margin: '8px 0' }} />

                                        {exam.answers.map((ans) => (
                                            <Box
                                                key={ans.id}
                                                p={1}
                                                mb={1}
                                                ml={2}
                                                borderRadius={8}
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                style={{
                                                    backgroundColor: ans.is_correct
                                                        ? '#e6ffed'
                                                        : ans.is_user_answer
                                                            ? '#ffe6e6'
                                                            : '#f5f5f5',
                                                    border: ans.is_correct
                                                        ? '1px solid #00c853'
                                                        : ans.is_user_answer
                                                            ? '1px solid #d32f2f'
                                                            : '1px solid #ddd',
                                                }}
                                            >
                                                <Typography variant="h6" style={{ fontWeight: 400 }}>
                                                    {String.fromCharCode(97 + ans.order)}) {ans.description}
                                                </Typography>
                                                <Box>
                                                    {ans.is_correct && (
                                                        <Chip
                                                            size="small"
                                                            className={classes.correct}
                                                            label="Resposta Correta"
                                                            style={{ fontSize: '0.65rem' }}
                                                        />
                                                    )}
                                                    {ans.is_user_answer && !ans.is_correct && (
                                                        <Chip
                                                            size="small"
                                                            className={classes.wrong}
                                                            label="Resposta Escolhida"
                                                            style={{ fontSize: '0.65rem' }}
                                                        />
                                                    )}
                                                </Box>
                                            </Box>
                                        ))}
                                    </CardContent>
                                </Card>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                </Box>
            ))}
        </Box>
    );
};

export default UserExams;
